import { API } from './resources'

export default {
  logLinkClick: (id, url) => {
    return API.post(`/projects/${id}/linkClick`, { url })
  }
}
